<template>
  <div>
    <b-card-header class="border-0">
      <b-row>
        <b-col class="col-sm-10">
          <h3 class="mb-0">Payment Plans</h3>
        </b-col>
        <b-col style="text-align: right"> </b-col>
      </b-row>
    </b-card-header>

    <el-table
      id="paymentPlanTable"
      class="table-responsive table-flush hover"
      header-row-class-name="thead-light"
      :data="paymentPlans"
      type="selection"
      @row-click="handleClick"
      hover
      @sort-change="sortChange"
    >
      <el-table-column
        label="Created"
        prop="created"
        min-width="125px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          {{ row.created | moment("MM/DD/YYYY") }}<br />
          <small>{{ row.created | moment("hh:mm:ss A") }}</small>
        </template>
      </el-table-column>

      <el-table-column
        label="Patient"
        min-width="100px"
        sortable="custom"
        prop="lastName"
        v-if="!supressPatientName"
      >
        <template v-slot="{ row }">
          {{ row.firstName }} {{ row.lastName }}
        </template>
      </el-table-column>

      <el-table-column
        label="Next Payment"
        prop="_NextBillingDate"
        min-width="95px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          {{ row.nextBillingDate | moment("MM/DD/YYYY") }}
        </template>
      </el-table-column>

      <el-table-column
        label="Balance"
        prop="_PaymentPlanTotal"
        min-width="90px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          {{ (row.balanceDue / 100) | currency }}
        </template>
      </el-table-column>

      <el-table-column
        label="Past Due"
        prop="_BalancePastDue"
        min-width="90px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          {{ (row.balancePastDue / 100) | currency }}
        </template>
      </el-table-column>

      <el-table-column
        label="Progress"
        min-width="100px"
        prop="status"
        sortable="custom"
      >
        <template v-slot="{ row }">
          <template v-if="row.status == 'ACTIVE'">
            <b-row>
              <b-col>
                <base-progress
                  v-if="row.cycle > 0"
                  height="8"
                  animated="true"
                  variant="success"
                  type="Completion"
                  :value="((row.cycle / row.cycleCount) * 100).toFixed(0)"
                />
              </b-col>
            </b-row>
            <template v-if="row.cycle == 0">
              Starting
              {{ row.nextBillingDate | moment("MM/DD/YYYY") }}
            </template>

            <template v-if="row.cycle > 0">
              <small class="text-success">
                <b-row>
                  <b-col>
                    <span>
                      {{ row.status | title }} {{ row.cycle }} of
                      {{ row.cycleCount }}
                    </span>
                  </b-col>
                </b-row>
              </small>
            </template>
          </template>
          <template v-if="row.status == 'INACTIVE'">
            <div class="text-muted">
              <b-row>
                <b-col>
                  <div>Canceled</div>
                  <small>{{ row.cancelledDate | moment("MM/DD/YYYY") }}</small>
                </b-col>
              </b-row>
            </div>
          </template>

          <template v-if="row.status == 'COMPLETE'">
            <b-row>
              <b-col>
                <div class="text-primary">
                  Completed<br />
                  <small>{{ row.completedDate | moment("MM/DD/YYYY") }}</small>
                </div>
              </b-col>
            </b-row>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <b-pagination
      v-if="showPagination"
      align="center"
      class="mt-3"
      v-model="page"
      :total-rows="rows"
      :per-page="perPage"
      @change="pageChange"
    ></b-pagination>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "paymentPlan-search-results",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    query: {},
    supressPatientName: false,
  },
  watch: {
    query: {
      immediate: true,
      async handler(newVal) {
        this.page = 1;
        this.bind();
      },
      deep: true,
    },
  },
  data() {
    return {
      rows: null,
      perPage: 10,
      page: 1,
      sort: "Created:Descending",
      paymentPlans: [],
      showPagination: false,
    };
  },
  mounted() {},
  methods: {
    sortChange(a) {
      var self = this;
      self.page = 1;

      if (a.prop && a.order) self.sort = a.prop + ":" + a.order;
      else self.sort = null;

      this.bind();
    },
    pageChange(pg) {
      this.page = pg;
      this.bind();
    },
    handleClick(item) {
      this.$emitter.emit("show-paymentplan", item.id);
    },
    bind() {
      var self = this;

      var form = this.query;

      form.sort = self.sort;
      form.page = self.page;

      self.$client
        .post("/api/paymentplan/paymentPlans", form)
        .then((response) => {
          if (response.data.isSuccess) {
            self.paymentPlans = response.data.value;
            self.rows = response.data.value[0].rowCount;
            self.showPagination = self.rows > 10;
          }
        });
    },
  },
};
</script>
<style>
body #paymentPlanTable tr:hover {
  background-color: #f6f9fc;
  cursor: pointer;
}
</style>
